export const PRIMARY_MANIFEST_FIXTURE_URL = 'https://dms-data.stanford.edu/data/manifests/Parker/nb647fd0133/manifest.json';
export const PRIMARY_CANVAS_FIXTURE_URL = 'https://dms-data.stanford.edu/data/manifests/Parker/nb647fd0133/canvas/canvas-1';
